export default __webpack_public_path__ + "static/media/36.d0d99e0f.jpg";